import { render } from "./MainCustomerOrder.vue?vue&type=template&id=6dba1f04&scoped=true"
import script from "./MainCustomerOrder.vue?vue&type=script&lang=js"
export * from "./MainCustomerOrder.vue?vue&type=script&lang=js"

import "./MainCustomerOrder.vue?vue&type=style&index=0&id=6dba1f04&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dba1f04"]])

export default __exports__